import React, { useEffect, useState } from "react";
import { http, formatApiError } from "@/lib/api";
import { Users, TrendingUp, Sparkles, Heart, Calendar, Coins, RefreshCw } from "lucide-react";

const STAGES = [
  { k: "active_profiles", label: "Actieve zoekprofielen", icon: Users },
  { k: "potential", label: "Potentiële matches", icon: TrendingUp },
  { k: "strong", label: "Sterke matches (≥80%)", icon: Sparkles },
  { k: "very_strong", label: "Zeer sterke matches (≥90%)", icon: Sparkles },
  { k: "interests", label: "Interesses ontvangen", icon: Heart },
  { k: "viewings", label: "Bezichtigingen", icon: Calendar },
  { k: "offers", label: "Biedingen", icon: Coins },
];

export default function FunnelWidget({ propertyId, scope = "admin" }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const load = async () => {
    if (!propertyId) return;
    setBusy(true); setErr(null);
    try {
      const url = scope === "seller" ? `/seller/properties/${propertyId}/funnel` : `/admin/properties/${propertyId}/funnel`;
      const { data } = await http.get(url);
      setData(data);
    } catch (e) { setErr(formatApiError(e)); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [propertyId]);

  if (err) return <p className="text-xs text-red-600">Funnel niet beschikbaar: {err}</p>;
  if (!data && !busy) return null;

  const maxVal = Math.max(...STAGES.map(s => (data?.[s.k] || 0)), 1);

  return (
    <div className="p-5 rounded-2xl bg-gradient-to-br from-[color:var(--wv-obsidian)] to-[#152449] text-white" data-testid="funnel-widget">
      <div className="flex items-center justify-between">
        <p className="font-display font-bold text-lg">Match-funnel</p>
        <button onClick={load} className="text-xs text-white/60 hover:text-white inline-flex items-center gap-1" data-testid="funnel-refresh"><RefreshCw className="w-3.5 h-3.5" /> Ververs</button>
      </div>
      {busy && <p className="mt-3 text-sm text-white/60">Laden…</p>}
      {data && (
        <div className="mt-4 space-y-2">
          {STAGES.map((s) => {
            const val = data[s.k] ?? 0;
            const pct = Math.max(6, Math.round((val / maxVal) * 100));
            return (
              <div key={s.k} className="flex items-center gap-3" data-testid={`funnel-${s.k}`}>
                <s.icon className="w-4 h-4 text-[color:var(--wv-green)] flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between text-xs">
                    <span className="text-white/80">{s.label}</span>
                    <span className="font-mono-num font-bold">{val}</span>
                  </div>
                  <div className="mt-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
                    <div className="h-full bg-[color:var(--wv-green)] rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
